import { Injectable } from "@angular/core";
import { GenericService } from "./generic.service";

@Injectable({ providedIn: "root" })
export class UserProfileService {
  constructor(private apiService:GenericService) {}

  getAll() {
    return this.apiService.Get<any>(`user/get-list`);
  }

  DeleteById(id: any) {
    return this.apiService.Get<any>(`user/delete/${id}`);
  }

  register(user: any) {
    return this.apiService.Post<any>(`user/register`, user);
  }
  getUserById(id:any){
    return this.apiService.Get<any>(`user/get-by-id/${id}`);
  }
  pagination(model: any) {
    return this.apiService.Post<any>(`user/pagination`, model);
  }

  getAllDepartments(){
    return this.apiService.Get<any>(`department/get-list`);
  }

  addNewDepartment(model:any){
    return this.apiService.Post<any>(`department/create-or-update`, model);
  }
  addNewCompany(model:any){
    return this.apiService.Post<any>(`company/create-or-update`, model);
  }

  
}
